import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription, isObservable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

interface MemoizedValue<T> {
  observable: Observable<T>;
  value: T;
}

@Pipe({
  name: 'push',
  pure: false
})
export class PushPipe implements PipeTransform, OnDestroy {
  
  protected readonly memoizedValues: Map<Observable<any>, MemoizedValue<any>> = new Map<Observable<any>, MemoizedValue<any>>();
  protected subs!: Subscription | null;

  constructor(protected readonly changeDetectorRef: ChangeDetectorRef) {}

  public transform<T>(observable: Observable<T>): T{
    if (!isObservable(observable)) return observable;
    if (this.memoizedValues.has(observable)) return this.memoizedValues.get(observable)?.value;

    this.unsubscribe();
    this.subs = observable.pipe(distinctUntilChanged()).subscribe((value: T) => this.updateValue(observable, value));

    return this.memoizedValues.get(observable)?.value;
  }

  public ngOnDestroy(): void{ this.unsubscribe(); }

  protected updateValue<T>(observable: Observable<T>, value: T): void{
    const memoizedValue = this.memoizedValues.get(observable)?.value;

    if (!memoizedValue || JSON.stringify(memoizedValue) !== JSON.stringify(value)) {
      this.memoizedValues.set(observable, { observable, value });
      this.changeDetectorRef.detectChanges();
    } 
  }

  protected unsubscribe(): void{
    this.subs?.unsubscribe();
    this.subs = null;
  }
}
